import {
  Box,
  Button,
  Card,
  Typography,
  useMediaQuery,
  IconButton,
} from '@mui/material'
import Page from '../../../components/page/Page'
import Span from '../../../components/Span'
import NearMeIcon from '@mui/icons-material/NearMe'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { useState, useEffect } from 'react'

import cardiffImg1 from '../../../assets/images/cardiff/hyve-gym-cardiff-14.jpeg'
import cardiffImg2 from '../../../assets/images/cardiff/hyve-gym-cardiff-15.jpeg'
import cardiffImg3 from '../../../assets/images/cardiff/hyve-gym-cardiff-16.jpeg'
import cardiffImg4 from '../../../assets/images/cardiff/hyve-gym-cardiff-17.jpeg'
import cardiffImg5 from '../../../assets/images/cardiff/hyve-gym-cardiff-18.jpeg'
import cardiffImg6 from '../../../assets/images/cardiff/hyve-gym-cardiff-19.jpeg'
import cardiffImg7 from '../../../assets/images/cardiff/hyve-gym-cardiff-20.jpeg'
import cardiffImg8 from '../../../assets/images/cardiff/hyve-gym-cardiff-21.jpeg'
import cardiffImg9 from '../../../assets/images/cardiff/hyve-gym-cardiff-22.jpeg'

const cardiffImages = [
  cardiffImg1,
  cardiffImg2,
  cardiffImg3,
  cardiffImg4,
  cardiffImg5,
  cardiffImg6,
  cardiffImg7,
  cardiffImg8,
  cardiffImg9,
]

const LLanelli = ({ subscriptionData }) => {
  const mobile = useMediaQuery('(max-width:900px)')
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === cardiffImages.length - 1 ? 0 : prevIndex + 1
      )
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? cardiffImages.length - 1 : prevIndex - 1
    )
  }

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === cardiffImages.length - 1 ? 0 : prevIndex + 1
    )
  }

  return (
    <Page>
      <Typography
        variant='h2'
        color='white.main'
        sx={{ fontSize: mobile ? '2em' : '3em' }}
      >
        Home <Span>sweat</Span> home
      </Typography>

      <Box
        display={'grid'}
        gridTemplateColumns={mobile ? '1fr' : '1fr 2fr'}
        gap={1}
      >
        <Card
          variant='outlined'
          sx={{
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
            p: 2,
            borderRadius: 1,
            order: mobile ? 1 : 0,
          }}
        >
          <Typography variant='h3' color='white.main' mb={2}>
            Cardiff
          </Typography>

          <Box display={'flex'} flexDirection='column' gap={3}>
            <Box display={'flex'} justifyContent={'space-between'} gap={2}>
              <Typography color={'primary'}>Gym hours</Typography>
              <Typography variant='body2'>7 days, 5AM - 10PM</Typography>
            </Box>

            <Box display={'flex'} justifyContent={'space-between'} gap={2}>
              <Typography color={'primary'} width={'130px'}>
                Manned hours
              </Typography>
              <Box display={'flex'} flexDirection={'column'} gap={0.5}>
                <Box display={'flex'} justifyContent={'space-between'} gap={3}>
                  <Typography variant='body2' fontWeight={600}>
                    Mon-Fri:
                  </Typography>
                  <Typography variant='body2'>6am - 10pm</Typography>
                </Box>
                <Box display={'flex'} justifyContent={'space-between'} gap={3}>
                  <Typography variant='body2' fontWeight={600}>
                    Sat-Sun:
                  </Typography>
                  <Typography variant='body2'>8am - 2pm</Typography>
                </Box>
              </Box>
            </Box>

            <Box display={'flex'} justifyContent={'space-between'} gap={2}>
              <Typography color={'primary'}>Address</Typography>
              <Box display={'stack'} textAlign={'right'}>
                <Typography variant='body2'>Unit 9</Typography>
                <Typography variant='body2'>
                  Colchester Avenue Ind Estate
                </Typography>
                <Typography variant='body2'>Cardiff</Typography>
                <Typography mb={2} variant='body2'>
                  CF23 9AP
                </Typography>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://www.google.com/maps/place/Crossfit+Cardiff/@51.4965402,-3.1523159,259m/data=!3m1!1e3!4m15!1m8!3m7!1s0x486e1ce0d7a799d1:0x80fbdaa0538479d7!2sPen-y-lan,+Cardiff+CF23+9AP!3b1!8m2!3d51.4962788!4d-3.1516326!16s%2Fg%2F1tcv5r89!3m5!1s0x486e1d130e0a3d6b:0x2d31efa333b3a304!8m2!3d51.496497!4d-3.152067!16s%2Fg%2F1tfdcx04?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D'
                >
                  <Button variant='outlined'>view on map</Button>
                </a>
              </Box>
            </Box>

            <Box display={'flex'} justifyContent={'space-between'} gap={2}>
              <Typography color={'primary'}>Contact</Typography>
              <a href='mailto:hi@trainhyve.com'>
                <Button>
                  <Typography variant='body2'>hi@trainhyve.com</Typography>
                </Button>
              </a>
            </Box>
          </Box>
        </Card>
        <Box
          sx={{
            position: 'relative',
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
            borderRadius: 1,
            overflow: 'hidden',
            height: mobile ? '400px' : '700px',
          }}
        >
          <Box
            component='img'
            src={cardiffImages[currentImageIndex]}
            alt={`Cardiff gym ${currentImageIndex + 1}`}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
          <IconButton
            onClick={handlePrevious}
            sx={{
              position: 'absolute',
              left: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: 1,
            }}
          >
            {cardiffImages.map((_, index) => (
              <Box
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    index === currentImageIndex
                      ? 'primary.main'
                      : 'rgba(255, 255, 255, 0.5)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
      <Box my={6}>
        <Typography variant='h3' color='white.main' mb={4}>
          Class <Span>Timetables</Span>
        </Typography>

        <Box mb={5}>
          <Typography variant='h5' color='white.main' mb={2}>
            Hyrox
          </Typography>
          <Box
            sx={{
              border: (theme) => `1px solid ${theme.palette.primary.main}`,
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            <Box
              component='table'
              sx={{
                width: '100%',
                borderCollapse: 'collapse',
                '& th, & td': {
                  p: 1.5,
                  textAlign: 'left',
                  borderBottom: (theme) =>
                    `1px solid ${theme.palette.primary.main}30`,
                },
                '& th': {
                  color: 'primary.main',
                  fontWeight: 600,
                },
                '& td': {
                  color: 'white.main',
                },
                '& tr:last-child td': {
                  borderBottom: 'none',
                },
              }}
            >
              <thead>
                <tr>
                  <th>Days</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Monday – Friday</td>
                  <td>07:00 – 08:00</td>
                </tr>
                <tr>
                  <td>Monday – Friday</td>
                  <td>19:15 – 20:15</td>
                </tr>
                <tr>
                  <td>Saturday</td>
                  <td>07:30 – 08:30</td>
                </tr>
              </tbody>
            </Box>
          </Box>
        </Box>

        <Box>
          <Typography variant='h5' color='white.main' mb={2}>
            CrossFit Cardiff
          </Typography>
          <Box
            sx={{
              border: (theme) => `1px solid ${theme.palette.primary.main}`,
              borderRadius: 1,
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
            }}
          >
            <Box
              component='table'
              sx={{
                width: '100%',
                minWidth: '600px',
                borderCollapse: 'collapse',
                '& th, & td': {
                  p: 1.5,
                  textAlign: 'center',
                  borderBottom: (theme) =>
                    `1px solid ${theme.palette.primary.main}30`,
                },
                '& th': {
                  color: 'primary.main',
                  fontWeight: 600,
                },
                '& td': {
                  color: 'white.main',
                },
                '& th:first-of-type, & td:first-of-type': {
                  textAlign: 'left',
                },
                '& tr:last-child td': {
                  borderBottom: 'none',
                },
              }}
            >
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>06:00</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                </tr>
                <tr>
                  <td>08:00</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                </tr>
                <tr>
                  <td>17:15</td>
                  <td>WOD</td>
                  <td>Gymnastics</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>Weightlifting</td>
                </tr>
                <tr>
                  <td>18:15</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                  <td>WOD</td>
                </tr>
              </tbody>
            </Box>
          </Box>
          <Box mt={2} display='flex' flexDirection='column' gap={0.5}>
            <Typography color='white.main' variant='body2'>
              <Typography component='span' color='primary.main' variant='body2' fontWeight={600}>
                Saturday
              </Typography>{' '}
              09:00 – 10:30 Partner WOD
            </Typography>
          </Box>
          <Typography color='white.main' variant='body2' mt={2}>
            For all classes — no need to book, just turn up! If you miss a class or can't make the schedule, the gym is open 5AM – 10PM, 7 days a week, and you can train any time with your access card. You'll be added to a programming group to receive the workouts for the day.
          </Typography>
        </Box>
      </Box>

      <Box
        display={'grid'}
        gridTemplateColumns={mobile ? '1fr' : '2fr 1fr'}
        gap={mobile ? 10 : 30}
      >
        <Box>
          <Typography variant='h3' color='white.main' my={4}>
            Why join us?
          </Typography>
          <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>No</Span> Contract
            </Typography>
            <Typography>
              Setting the precedent for local gyms; no contract, cancel anytime
              online, in minutes.
            </Typography>
          </Box>
          <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>No</Span> Joining fee
            </Typography>
            <Typography>
              At HYVE, there are no hidden costs and everybody is welcome to
              join.
            </Typography>
          </Box>
          {/* <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>Free</Span> Classes
            </Typography>
            <Typography>
              Discover our diverse range of engaging, results-driven classes led
              by expert instructors. From calorie-torching HIIT sessions to
              rejuvenating yoga flows, there's something for everyone. Boost
              your strength, flexibility, and endurance while connecting with
              our supportive fitness community.
            </Typography>
          </Box> */}
          <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>Free</Span> Trial
            </Typography>
            <Typography>
              As standard, all memberships 1 month+ include a free trial. Feel
              free to give us a try, but if something doesn’t suit you, just
              cancel online within 24 hours and you won't be charged. No hard
              feelings.
            </Typography>
          </Box>
          <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>No</Span> Time restrictions
            </Typography>
            <Typography>
              All of our memberships include full access to the facility. No
              peak or off-peak limitations.
            </Typography>
          </Box>
          <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>Free</Span> HYVE credits
            </Typography>
            <Typography>
              For every pound you invest in a HYVE membership, you'll earn an
              equal number of HYVE credits, which can be redeemed for guest
              passes and more.
            </Typography>
            {/* <Typography mt={1}>
              For instance, a £29 individual monthly membership grants you 29
              credits. You can then use these credits for: <br />
              4 guest passes <br />3 hours in a private studio or pool
            </Typography> */}
          </Box>
          {/* <Box my={4}>
            <Typography color={'white.main'} variant='h5' mb={2}>
              <Span>Private</Span> Studio hire
            </Typography>
            <Typography>
              Looking for an exclusive space to exercise with friends? HYVE
              provides an array of micro-gym areas and wellness amenities
              tailored to diverse workout preferences. Utilize your credits to
              reserve a studio and feel free to invite anyone, even non-members,
              to join your fitness session.
            </Typography>
          </Box> */}
        </Box>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'start'}
          flexDirection={'column'}
        >
          {!subscriptionData && (
            <>
              <Box
                sx={{
                  border: (theme) => `1px solid ${theme.palette.primary.main}`,
                  p: 5,
                  borderRadius: 1,
                }}
              >
                <Typography variant='h3' color='white.main'>
                  {' '}
                  What are you waiting for?
                </Typography>
                <Link to='/join'>
                  <Button size='large' sx={{ mt: 2, fontSize: '1.2rem' }}>
                    JOIN NOW
                  </Button>
                </Link>
              </Box>
              <NearMeIcon
                color='white'
                fontSize='large'
                sx={{ mt: -2, ml: -2 }}
              />
            </>
          )}
        </Box>
      </Box>
    </Page>
  )
}

const mapStateToProps = ({ user, subscription }) => ({
  currentUser: user.currentUser,
  subscriptionData: subscription.currentSubscription,
})

export default connect(mapStateToProps, null)(LLanelli)
